export const header = () => {
  const header = document.querySelector('.js-header');
  if (!header) return;

  let lastScroll = 0;
  const showThreshold = 20; // Minimum pixels to scroll up before showing header
  
  // Get scroll threshold based on hero section if it exists
  const hero = document.querySelector('.c-page-hero');
  const scrollThreshold = hero ? hero.offsetHeight : 100;

  const handleScroll = () => {
    const currentScroll = window.pageYOffset;
    const scrollDiff = lastScroll - currentScroll; // Positive when scrolling up

    // Only trigger if we've scrolled more than the threshold
    if (Math.abs(currentScroll - lastScroll) < 5) return;

    if (currentScroll > lastScroll && currentScroll > scrollThreshold) {
      // Scrolling down
      header.classList.add('is-hidden');
    } else if (scrollDiff > showThreshold || currentScroll === 0) {
      // Scrolling up and past the show threshold OR at the top of the page
      header.classList.remove('is-hidden');
    }

    lastScroll = currentScroll;
  };

  // Add scroll event listener
  window.addEventListener('scroll', handleScroll);
}; 